export const SANCTIONS_TABLE_HEADER = [
  { key: 'purchaseOrder', label: 'Orden de compra', width: '400px' },
  { key: 'organization', label: 'Organismo', width: '300px' },
  { key: 'date', label: 'Aceptación OC', width: '140px' },
  { key: 'state', label: 'Estado', width: '120px' },
  { key: 'detail', label: 'Acciones', width: '120px' }
]

export const SANCTIONS_TABLE_LABEL = 'Tabla de sanciones históricas'

export const TYPE_DOCUMENT = {
  RES: 'Resolución',
  DEC: 'Decreto',
  OTR: 'Documento'
}
